import { supabase } from '@/lib/supabase';
import type { OrgBranch } from '@/types';

export const branchesApi = {
  async list(orgId: string): Promise<OrgBranch[]> {
    const { data, error } = await supabase
      .from('org_branches')
      .select('*')
      .eq('organization_id', orgId)
      .order('is_main', { ascending: false })
      .order('name');
    if (error) throw error;
    return data ?? [];
  },

  async create(
    branch: Partial<OrgBranch> & { organization_id: string; name: string; code: string }
  ): Promise<OrgBranch> {
    const { data, error } = await supabase
      .from('org_branches')
      .insert(branch)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async update(id: string, updates: Partial<OrgBranch>): Promise<OrgBranch> {
    const { data, error } = await supabase
      .from('org_branches')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },
};
